export const PLAY_INTENSITY_OPTIONS = [
  { value: 'ANY', label: 'ได้ทุกระดับ', icon: '⚪' },
  { value: 'LIGHT', label: 'เบา', icon: '🟢' },
  { value: 'MEDIUM', label: 'กลาง', icon: '🟡' },
  { value: 'HEAVY', label: 'หนัก', icon: '🔴' }
];

export const getPlayIntensity = value => (
  PLAY_INTENSITY_OPTIONS.find(item => item.value === String(value || 'ANY').toUpperCase())
  || PLAY_INTENSITY_OPTIONS[0]
);

export const openAdminPlayerEditor = player => {
  window.dispatchEvent(new CustomEvent('admin-edit-player', { detail: player }));
};
